import { Pipe, PipeTransform } from '@angular/core';

/*
 * <div innerHTML="{{ str | highlight : 'search'}}"></div>
 */
@Pipe({
  name: 'appHighlight',
})
export class HighlightPipe implements PipeTransform {
  transform(value: string, arg: string): string {
    if (value == null || value.length === 0 || arg == null || arg.length === 0) {
      return value;
    }
    value = value.toString();
    const startIndex = value.toLowerCase().indexOf(arg.toLowerCase());
    if (startIndex === -1) {
      return value;
    }

    const endLength = arg.length;
    const matchingString = value.substr(startIndex, endLength);

    return value.replace(matchingString, '<mark class="highlight">' + matchingString + '</mark>');
  }
}
